import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { FileManagerConst } from 'src/app/core/constants/file-manager.const';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { MyDriveService } from 'src/app/core/services/myDrive/my-drive.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';

@Component({
  selector: 'app-create-folder-dialog',
  templateUrl: './create-folder-dialog.component.html',
  styleUrls: ['./create-folder-dialog.component.scss']
})
export class CreateFolderDialogComponent implements OnInit, OnDestroy {
  folder_form: FormGroup;
  private _unsubscribeAll: Subject<any> = new Subject();
  submitted: boolean = false;
  drive_type = FileManagerConst.DriveTypeIds;

  constructor(
    public dialogRef: MatDialogRef<CreateFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _driveService: MyDriveService,
    private _loaderService: LoaderService,
    private _toasterSevrice: ToasterService,
    private _fb: FormBuilder
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    this.folder_form = this._fb.group({
      name: [this.data?.name ?? '', Validators.required],
      type: [this.data?.type ?? this.drive_type.home],
      filePath: [this.data?.folderPath ?? '/']
    })
  }

  close(val?: boolean) {
    this.dialogRef.close(val);
  }

  submit() {
    this.submitted = true
    if (this.folder_form.invalid) {
      return;
    }

    if (this.data?.id) {
      this.updateFolder();
    } else {
      this.addFolder();
    }
  }

  addFolder() {
    this._loaderService.showLoader();
    this._driveService.createFolder(this.folder_form.value)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((res: any) => {
      if (res) {
        this._toasterSevrice.showSuccess('SUCCESS', 'Folder created successfully');
        this.close(true);
      }
      this._loaderService.hideLoader();
    }, (err) => {
      this._loaderService.hideLoader();
    })
  }

  updateFolder() {
    delete this.folder_form.value.type;
    delete this.folder_form.value.filePath;
    
    this._loaderService.showLoader();
    this._driveService.updateFolder(this.data.id, this.folder_form.value)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((res: any) => {
      if (res) {
        this._toasterSevrice.showSuccess('SUCCESS', 'Folder updated successfully');
        this.close(true);
      }
      this._loaderService.hideLoader();
    }, (err) => {
      this._loaderService.hideLoader();
    })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}

